module.exports = "//public.zight.com/packs/media/images/icons-share-settings-locked-7c829e96b7c55a48ba7732bad8bbfd31.svg";